import React, { Fragment, useEffect, useState, useCallback } from "react";
import { set_services } from "../../../redux/actions/ServicesAction";
import { connect } from "react-redux";
import { apiJson } from "../../../api/Api";
import { toast } from "react-toastify";
import { set_loading } from "../../../redux/actions/LayoutAction";
import TableList from "./TableList";
import { Redirect, useLocation } from "react-router-dom";
import Header from "../subheader/Header";
import ServiceBulkImportModal from "../../../components/modal/ServiceBulkImportModal";
import HeaderTab from "../order/tab/HeaderTab";
import "./servicecatalog.scss";
import { tabParam } from "../../../utils/utils";
import { debounce } from "lodash";

const ServiceCatalog = (props) => {
  const location = useLocation();
  const [redirect, setRedirect] = useState(false);
  const [data, setData] = useState(false);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [headerList, setHeaderList] = useState([]);
  const [searchText, setSearchText] = useState("");

  const [currTab, setCurrTab] = useState("active");

  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const getServices = (page, remainingParams) => {
    document.getElementById("rightContent").scrollTop = 0;
    setData(false);
    apiJson.services.getServices(page, remainingParams).then((response) => {
      if (response.success) {
        props.set_services({
          services: response.data.services,
          pagination: response.data.pagination,
        });
        setData(true);
      } else if (!response.status) {
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
        setData(true);
      } else {
        setData(true);
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
  };
  const changeTab = (tabName) => {
    if (tabName.toLowerCase() !== currTab) {
      setCurrTab(tabName.toLowerCase());
      getServices(
        1,
        tabParam(tabName.toLowerCase()) +
          (searchText?.length > 0 ? "&search_by_name=" + searchText : "")
      );
    }
  };

  const pageChange = (page) => {
    getServices(
      page,
      tabParam(currTab) +
        (searchText?.length > 0 ? "&search_by_name=" + searchText : "")
    );
  };

  useEffect(() => {
    document.title = "Services";
  }, []);

  useEffect(() => {
    getServices(
      1,
      tabParam(currTab) +
        (searchText?.length > 0 ? "&search_by_name=" + searchText : "")
    );

    apiJson.services.getTabsCount().then((response) => {
      response.success
        ? setHeaderList({
            id: "productlist",
            tablist: [
              { id: "active", count: response.data.active },
              { id: "inactive", count: response.data.inactive },
              {
                id: "uncategorized",
                count: response.data.uncategorized,
              },
            ],
          })
        : setHeaderList({
            id: "productlist",
            tablist: [
              { id: "active", count: 0 },
              { id: "inactive", count: 0 },
              { id: "uncategorized", count: 0 },
            ],
          });
    });
    // eslint-disable-next-line
  }, [location.state?.name]);

  const debouncedCallback =
    // eslint-disable-next-line
    useCallback(
      debounce((text, currTab) => handleSearch(text, currTab), 1000),
      []
    );

  const handleSearch = (text, tabName) => {
    getServices(1, tabParam(tabName) + "&search_by_name=" + text);
  };

  const bulkImport = () => {
    setShowBulkModal(true);
  };

  const createClick = () => {
    setShowBulkModal(false);
  };

  const cancelClick = () => {
    setShowBulkModal(false);
  };

  // eslint-disable-next-line
  useEffect(() => props.set_loading(!data), [data]);
  return (
    <Fragment>
      {showBulkModal && (
        <div className="product-import-modal-container">
          <ServiceBulkImportModal
            heading="Bulk Import Service"
            cancleClick={cancelClick}
            createClick={createClick}
            dataType={"services"}
          />
        </div>
      )}
      <div className="vendor-page-right service-catalog-page-desktop">
        <Header
          heading="View Services"
          search={true}
          filters={null}
          handleSearch={(text) => {
            setSearchText(text);
            debouncedCallback(text, currTab);
          }}
        />
        <div className="right-content content-container-row">
          <div className="content w-100">
            <button
              type="button"
              className="create-button"
              onClick={() => setRedirect(true)}
            >
              Create New Service
            </button>
            <button
              type="button"
              className="create-button"
              onClick={bulkImport}
            >
              Bulk import Services
            </button>
            <HeaderTab
              onTabChoose={changeTab}
              currTab={currTab}
              tab={headerList}
            >
              <TableList
                List={props.services}
                pageChange={pageChange}
                pagination={props.pagination}
              />
            </HeaderTab>
          </div>
        </div>
      </div>

      {redirect && (
        <Redirect
          push
          to={{ pathname: "/vendor/service", state: { name: "create" } }}
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    pagination: state.service.pagination,
    services: state.service.services,
    load: state.layout.isLoading,
  };
};

const mapDispatchTopProps = { set_services, set_loading };

export default connect(mapStateToProps, mapDispatchTopProps)(ServiceCatalog);
